var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgErrorPage = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297,
    height: 297,
    fill: "none",
    viewBox: "0 0 297 297",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1C445A",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M148.5 294c80.357 0 145.5-65.143 145.5-145.5S228.857 3 148.5 3 3 68.143 3 148.5 68.143 294 148.5 294Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1C445A",
    strokeWidth: 5,
    d: "M68.768 84.863h159.464a3.5 3.5 0 0 1 3.5 3.5v117.334a3.5 3.5 0 0 1-3.5 3.5H68.768a3.5 3.5 0 0 1-3.5-3.5V88.363a3.5 3.5 0 0 1 3.5-3.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C445A",
    strokeWidth: 5,
    d: "M62.768 104.328h171.464M147.957 167.414v9.458a9.457 9.457 0 0 0 9.458 9.457 9.457 9.457 0 0 0 9.457-9.457v-9.458"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C445A",
    d: "M154.912 173.516a2.5 2.5 0 0 0 5 0zm5 0v-4.439h-5v4.439z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C445A",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M176.577 168.324h-57.286"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C445A",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "m176.162 131.578-16.203 16.203M159.959 131.578l16.203 16.203M120.84 131.578l16.203 16.203M137.043 131.578l-16.203 16.203"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C445A",
    strokeWidth: 5,
    d: "M75.506 95.074h5.879M85.777 95.074h5.879M96.053 95.074h5.879"
  })));
};
const Memo = /*#__PURE__*/memo(SvgErrorPage);
export default Memo;